import { Box, styled, Typography, useTheme } from "@mui/material";
import { Link, useParams } from "react-router-dom";
import summitLogo from "./summitLogo.png";
// import { ReactComponent as SummitLogo } from "./summitNewLogo.svg";

const LogoWrapper = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column", // Stack vertically
  justifyContent: "center",
  alignItems: "center",
  // width: "220px",
  height: "auto", // let it grow with content
  gap: "0.25rem",
  textDecoration: "none",
  paddingLeft: "0px",
}));

function Logo() {
  const { pId } = useParams();
  const theme = useTheme();
  return (
    <Link to={`/dashboard/${pId}`} style={{ textDecoration: "none" }}>
      <LogoWrapper>
        <img src={summitLogo} alt="Summit" width="150" />
        {/* <SummitLogo /> */}
      </LogoWrapper>
    </Link>
  );
}

export default Logo;
